<!-- <p>organisation-datapoints works!</p> -->
<app-dialog-header headerText="Select Datapoints" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="width: 500px;">
		<mat-form-field>
			<input matInput autocomplete="off" id="tableFilter" (keyup)="applyFilter($event)"
				placeholder="Filter Datapoints List" style="margin-left: 1em;margin-right: 1em;width: 450px;">
		</mat-form-field>
		<ejs-listview id='sample-list' #samplelist
			cssClass='e-list-template'
			style="height: 350px;margin-bottom: 1em;"
			(select)="onSelectionChange($event)"
			[dataSource]='displayedDatapoints'
			[fields]='fields'
			[showCheckBox]='true'
			checkBoxPosition=true>
		</ejs-listview>
	</div>

	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value"
			[disabled]="dialogForm.invalid">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>


<!-- <ng-template #assetDatapoints>
	<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='displayedDatapoints' [showCheckBox]="true"
		cssClass='e-list-template' style="height: 350px;margin-bottom: 1em;" (select)="onSelectionChange($event)">
		<ng-template #template let-dataSource>
			<div class="dp-list-wrapper" style="border-bottom: inset" (click)="selectDataPoint(dataSource.DataPointID)">
				<div class="div1">
					<div class="div2">
						<img class="dataPointImage" src="{{dataSource.ImageURL}}"
							onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
							(click)="viewImage(dataSource.ImageURL)" [attr.x-contenttype]="'image/png'" />
						<div class="dataPointDetail">
							<div id="id-name" class="assetName">{{dataSource.SensorName}} - {{dataSource.PVDescription}}</div>
							<div id="id-publicID" class="assetInfo">PublicID: {{dataSource.PublicID }}</div>
							<div id="id-description" class="assetInfo">Name: {{dataSource.PVName }} ({{dataSource.SI }})
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</ejs-listview>
</ng-template> -->
